// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --accent-base-color: #85be40;
  --accent-fill-hover: #488100;

  --primary-color-1: #00ab55;

  --primary-color-hover-1: #007b55;
  --primary-color-hover-2: #ebf9f2;

  --color-text-1: #212529;
  --color-text-2: #fff;
  --color-text-3: #71717a;
  --color-text-4: #515151;

  --color-icon-1: #919eab;
  --color-icon-2: #414141;

  --color-hover-1: #e2e8f0;

  --border-color-1: #919eab3d;

  --background-color-1: #ffffff;
  --background-color-2: #edeff1;
  --background-color-3: #f2f3f5;
  --background-color-4: #fbfbfc;

  --scroll-color-track-1: transparent;
  --scroll-color-thumb-1: #cbd0d6;
  --scroll-color-thumb-hover-1: #b6bbc0;

  --dropdown-background-color-1: #ebebeb;
  --dropdown-background-color-2: #d7d7d7;
}

.darkmode {
  --color-text-1: #fff;
  --color-text-3: #e4e4e7;
  --color-text-4: #c9c9c9;

  --color-hover-1: #475569;

  --color-icon-2: #fff;

  --primary-color-hover-2: #1c3f3b;

  --color-icon-1: #e2e8f0;

  --background-color-1: #161c24;
  --background-color-2: #333d48;
  --background-color-3: #29333c;
  --background-color-4: #212b36;

  --scroll-color-thumb-1: #46525f;
  --scroll-color-thumb-hover-1: #37424d;

  --dropdown-background-color-1: #3b4957;
  --dropdown-background-color-2: #283543;
}

.darkmode .cesium-viewer {
  overflow: hidden;
  color: var(--color-text-1);
}

.DPU-container-view {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
  font-size: 14px;
  background-color: var(--background-color-1);
}

.DPU-container-view>* {
  box-sizing: border-box;
}

.DPU-container-view *::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  /* Scroll ngang */
}

.DPU-container-view *::-webkit-scrollbar-track {
  background: var(--scroll-color-track-1);
}

.DPU-container-view *::-webkit-scrollbar-thumb {
  background: var(--scroll-color-thumb-1);
}

.DPU-container-view *::-webkit-scrollbar-thumb:hover {
  background: var(--scroll-color-thumb-hover-1);
}

/* mặc định của cesium */
.cesium-viewer-bottom {
  display: none;
}

.custom-toolbar-dpu {
  position: absolute;
  right: 5px;
  top: 100px;
  z-index: 5;
  color: white;
  display: flex;
  flex-direction: column;
}

.custom-toolbar-dpu.resp-h400 {
  flex-direction: row;
  right: unset;
  top: unset;
  bottom: 25px;
  left: 50%;
  flex-direction: row;
  transform: translateX(-50%);
}

.custom-toolbar-dpu.resp-h400 .container-tool-cesium {
  flex-direction: row;
  margin-right: 5px;
}

.custom-toolbar-dpu.resp-h400 .container-tool-cesium .container-btn-tool-cesium {
  flex-direction: row;
}

.container-tool-cesium {
  display: flex;
  flex-direction: column;
  padding: 2px;
  border-radius: 4px;
  background-color: var(--background-color-1);
  box-shadow: 1px 3px 10px 0 rgba(0, 0, 0, 0.5);
  opacity: 0.85;
  border: none;
  margin-top: 5px;
}

.custom-toolbar-dpu.resp-h400 .container-tool-cesium>* {
  margin-top: 0px;
  margin-left: 0px;
}

/* .container-tool-cesium > * {
  margin-top: 2px;
} */

.custom-toolbar-dpu.resp-h400 .container-tool-cesium .container-btn-tool-cesium .container-tool-cesium>* {
  margin-left: 0px;
}

.custom-toolbar-dpu.resp-h400 .container-tool-cesium .container-btn-tool-cesium>*:first-child {
  margin-left: 0;
}

.custom-toolbar-dpu.resp-h400 .container-tool-cesium .container-btn-tool-cesium>* {
  margin-top: 0px;
  margin-left: 3px;
}

.custom-toolbar-dpu.resp-h400 .padding-btn-tool-cesium {
  margin-top: 0px;
  margin-left: 1px;
}

.custom-toolbar-dpu.resp-h400 .container-tool-cesium .container-btn-tool-cesium>*:first-child,
.custom-toolbar-dpu.resp-h400 .container-tool-cesium .container-btn-tool-cesium>*:nth-child(2) {
  margin-left: 0px;
}

.container-tool-cesium>*:first-child {
  margin-top: 0;
}

.container-btn-tool-cesium {
  display: flex;
  flex-direction: column;
}

.container-btn-tool-cesium>* {
  margin-top: 3px;
}

.container-btn-tool-cesium>*:first-child,
.container-btn-tool-cesium>*:nth-child(2) {
  margin-top: 0;
}

.padding-btn-tool-cesium {
  margin-top: 1px;
}

/* Tooltip Styles */
.dynamic-tooltip {
  position: absolute;
  background-color: var(--background-color-1);
  color: var(--color-icon-2);
  -webkit-box-shadow: 0px 0px 15px 0px rgba(170, 170, 170, 1);
  -moz-box-shadow: 0px 0px 15px 0px rgba(170, 170, 170, 1);
  box-shadow: 0px 0px 15px 0px rgba(170, 170, 170, 1);
  padding: 5px;
  border-radius: 4px;
  white-space: nowrap;
  font-size: 12px;
  z-index: 999;
  opacity: 0.85;
  transition: opacity 0.3s ease;
  text-align: right;
  direction: rtl;
}

/* Các hướng mũi tên */
.dynamic-tooltip-arrow-right,
.dynamic-tooltip-arrow-left,
.dynamic-tooltip-arrow-top,
.dynamic-tooltip-arrow-bottom,
.dynamic-tooltip-arrow-topLeft,
.dynamic-tooltip-arrow-topRight,
.dynamic-tooltip-arrow-bottomLeft,
.dynamic-tooltip-arrow-bottomRight {
  position: absolute;
}

/* Mũi tên bên phải */
.dynamic-tooltip-arrow-right::after {
  content: "";
  position: absolute;
  top: 50%;
  right: -5px;
  transform: translateY(-50%);
  border-top: 7px solid transparent;
  border-left: 10px solid var(--background-color-1);
  border-bottom: 7px solid transparent;
}

/* Mũi tên bên trái */
.dynamic-tooltip-arrow-left::after {
  content: "";
  position: absolute;
  top: 50%;
  left: -5px;
  transform: translateY(-50%);
  border-top: 7px solid transparent;
  border-right: 10px solid var(--background-color-1);
  border-bottom: 7px solid transparent;
}

/* Mũi tên phía trên */
.dynamic-tooltip-arrow-top::after {
  content: "";
  position: absolute;
  bottom: -5px;
  left: 50%;
  transform: translateX(-50%);
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 10px solid var(--background-color-1);
}

/* Mũi tên phía dưới */
.dynamic-tooltip-arrow-bottom::after {
  content: "";
  position: absolute;
  top: -5px;
  left: 50%;
  transform: translateX(-50%);
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 10px solid var(--background-color-1);
}

/* Mũi tên phía trên bên trái */
.dynamic-tooltip-arrow-topLeft::after {
  content: "";
  position: absolute;
  bottom: -5px;
  left: 0px;
  transform: translateX(0);
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 10px solid var(--background-color-1);
}

/* Mũi tên phía trên bên phải */
.dynamic-tooltip-arrow-topRight::after {
  content: "";
  position: absolute;
  bottom: -5px;
  right: 0px;
  transform: translateX(0);
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 10px solid var(--background-color-1);
}

/* Mũi tên phía dưới bên trái */
.dynamic-tooltip-arrow-bottomLeft::after {
  content: "";
  position: absolute;
  top: -5px;
  left: 0px;
  transform: translateX(0);
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 10px solid var(--background-color-1);
}

/* Mũi tên phía dưới bên phải */
.dynamic-tooltip-arrow-bottomRight::after {
  content: "";
  position: absolute;
  top: -5px;
  right: 0px;
  transform: translateX(0);
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 10px solid var(--background-color-1);
}

.btn-tool-cesium {
  border: 1px solid rgba(34, 34, 34, 0);
  border-radius: 4px;
  cursor: pointer;
  float: left;
  height: 28px;
  text-align: center;
  position: relative;
  width: 28px;
  padding: 2px 2px;
  background-color: transparent;
  line-height: 1px;
}

.btn-tool-cesium svg {
  width: 100%;
  height: 100%;
  color: var(--color-icon-2);
  stroke: var(--color-icon-2);
  fill: var(--color-icon-2);
}

.btn-tool-cesium:hover svg {
  color: var(--primary-color-1);
  stroke: var(--primary-color-1);
  fill: var(--primary-color-1);
}

.btn-tool-cesium.done {
  background-color: var(--primary-color-1);
  font-size: unset;
  width: 28px;
  height: 28px;
}

.btn-tool-cesium.done:hover {
  background-color: var(--primary-color-hover-1);
  border: 1px solid var(--primary-color-hover-1);
  color: #fff;
}

.btn-tool-cesium.done:hover svg {
  color: #fff;
  stroke: #fff;
  fill: #fff;
}

.btn-tool-cesium:hover {
  background-color: transparent;
  border: 1px solid var(--primary-color-1);
  color: var(--primary-color-1);
}

.btn-tool-cesium:focus {
  background-color: transparent;
  border-radius: 3px;
  box-shadow: inset 0 2px 2px 0 transparent;
  outline: none;
  border-color: transparent;
}

.btn-tool-cesium:focus:hover {
  border: 1px solid var(--primary-color-1);
}

.btn-tool-cesium:focus:hover svg {
  color: var(--primary-color-1);
  stroke: var(--primary-color-1);
  fill: var(--primary-color-1);
}

.btn-tool-cesium.active {
  background-color: transparent;
  border-radius: 3px;

  color: var(--primary-color-1);
  border: 1px solid var(--primary-color-1);
  outline: none;
}

.btn-tool-cesium.active svg {
  color: var(--primary-color-1);
  stroke: var(--primary-color-1);
  fill: var(--primary-color-1);
}

.zoom-earth {
  position: absolute;
  right: 5px;
  z-index: 5;
  color: white;
}

.zoom-earth.in {
  bottom: 105px;
}

.zoom-earth.out {
  bottom: 65px;
}

.zoom-earth.in.resp-zoom-earth-in-h550 {
  top: 50px;
  left: 5px;
  right: unset;
  bottom: unset;
}

.zoom-earth.out.resp-zoom-earth-out-h550 {
  top: 87px;
  left: 5px;
  right: unset;
  bottom: unset;
}

.body-dialog-valid-token {
  width: 100%;
  height: 100%;
  padding: 10px;
  display: flex;
}

.icon-dialog-error {
  background-color: #fff;
  border-radius: 50%;
  flex-shrink: 0;
}

.icon-dialog-error svg {
  width: 100%;
  height: 100%;
  fill: #d75a4a;
  stroke: #d75a4a;
}

input.dpu-input-check-box {
  cursor: pointer;
  accent-color: var(--primary-color-1);
}

input.dpu-input-check-box+label {
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
  margin-left: 5px;
}

input.dpu-input-text[type="number"]:focus,
input.dpu-input-text[type="number"]:focus-visible,
input.dpu-input-text[type="text"]:focus,
input.dpu-input-text[type="text"]:focus-visible {
  border: 1px solid var(--primary-color-1);
}

input.dpu-input-text[type="number"],
input.dpu-input-text[type="text"] {
  color: var(--color-text-1);
  width: 100%;
  height: 30px;
  border: 1px solid #ced4da;
  background: none;
  box-sizing: border-box;
  border-radius: 4px;
  padding-block: 0px;
  padding-inline: 0;

  padding-left: 8px;
  outline: none;
  box-shadow: none;
}

input.dpu-input-text[type="number"]::placeholder,
input.dpu-input-text[type="text"]::placeholder {
  color: var(--color-text-4);
}

input.dpu-inpu-color[type="color"] {
  background: var(--background-color-3);
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 0px 2px;
}

input.dpu-input-text[type="number"]::-webkit-outer-spin-button,
input.dpu-input-text[type="number"]::-webkit-inner-spin-button {
  width: 25px;
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  color: red;
}

/*********** Baseline, reset styles ***********/
input.dpu-input-range[type="range"] {
  width: 100%;
  -webkit-appearance: none;
  appearance: none;
  background: transparent;
  cursor: pointer;
}

/* Removes default focus */
input.dpu-input-range[type="range"]:focus {
  outline: none;
}

/******** Chrome, Safari, Opera and Edge Chromium styles ********/
/* slider track */
input.dpu-input-range[type="range"]::-webkit-slider-runnable-track {
  background-color: var(--background-color-3);
  border-radius: 5px;
  height: 5px;
}

/* slider thumb */
input.dpu-input-range[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none;
  /* Override default look */
  appearance: none;
  margin-top: -5.5px;
  /* Centers thumb on the track */
  background-color: var(--primary-color-1);
  border-radius: 50%;
  height: 12px;
  width: 12px;
}

input.dpu-input-range[type="range"]:focus::-webkit-slider-thumb {
  outline: 2px solid var(--primary-color-1);
  outline-offset: 2px;
}

/*********** Firefox styles ***********/
/* slider track */
input.dpu-input-range[type="range"]::-moz-range-track {
  background-color: var(--background-color-3);
  border-radius: 5px;
  height: 5px;
}

/* slider thumb */
input.dpu-input-range[type="range"]::-moz-range-thumb {
  background-color: var(--primary-color-1);
  border: none;
  /*Removes extra border that FF applies*/
  border-radius: 50%;
  height: 12px;
  width: 12px;
}

input.dpu-input-range[type="range"]:focus::-moz-range-thumb {
  outline: 2px solid var(--primary-color-1);
  outline-offset: 2px;
}

.dpu-select-box {
  position: relative;
  display: block;
  width: 100%;
  margin: 0 auto;
  font-size: 12px;
  color: #60666d;
}

.dpu-select-box__current {
  position: relative;
  cursor: pointer;
  outline: none;
  border-radius: 5px;
}

.dpu-select-box__current:focus+.dpu-select-box__list {
  opacity: 1;
  animation-name: none;
}

.dpu-select-box__current:focus .dpu-select-box__option {
  cursor: pointer;
}

.dpu-select-box__icon {
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  width: 10px;
  opacity: 0.3;
  transition: 0.2s ease;
}

.dpu-select-box__value {
  display: flex;
}

.dpu-select-box__input {
  display: none;
}

.dpu-select-box__input:checked+.dpu-select-box__input-text {
  display: block;
}

.dpu-select-box__input-text {
  display: none;
  width: 100%;
  margin: 0;
  padding: 0 5px;
  height: 30px;
  background-color: #fff;
  line-height: 30px;
  border-radius: 5px;
  border: 1px solid #ccc;
}

.dpu-select-box__list {
  position: absolute;
  width: 100%;
  padding: 0;
  list-style: none;
  opacity: 0;
  animation-name: dpuHideList;
  animation-duration: 0.5s;
  animation-delay: 0.5s;
  animation-fill-mode: forwards;
  animation-timing-function: step-start;
  background-color: #fff;
  max-height: 300px;
  overflow: auto;
  border-radius: 5px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.dpu-select-box__option {
  display: block;
  padding: 10px;
  /* background-color: #fff; */
}

.dpu-container-title {
  display: flex;
  align-items: center;
}

.dpu-container-title div:first-child {
  width: 3px;
  height: 15px;

  margin-right: 5px;
}

.dpu-select-box__option:hover,
.dpu-select-box__option:focus {
  color: #546c84;
  background-color: #fbfbfb;
}

@keyframes dpuHideList {
  from {
    transform: scaleY(1);
  }

  to {
    transform: scaleY(0);
  }
}

.dpu-tree-item.active .dpu-loading-animation {
  /* filter: grayscale(100%); */
  filter: grayscale(100%) brightness(1000%);
}

.dpu-loading-animation {
  animation: dpu-rotate-loading 1s linear infinite;
  max-width: none;
}

@keyframes dpu-rotate-loading {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.dpu-waiting-load-model {
  position: absolute;
  max-width: 200px;
  z-index: 10;
  bottom: 30px;
  left: 5px;
  padding: 5px 10px;
  background-color: var(--background-color-4);
  border-radius: 4px;
  color: var(--color-text-1);
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

/* Reusable Bottom-Left Status Stack Container */
#status-stack-container {
  position: absolute;
  bottom: 65px;
  left: 5px;
  z-index: 99;

  pointer-events: none;
  border-radius: 4px;
}

.status-stack-item {

  padding: 4px 6px;
  color: var(--color-text-1, #ffffff);
  border: 1px solid rgba(255, 255, 255, 0.1);
  background-color: var(--background-color-4);
  border-radius: 4px;
  font-family: inherit;
  font-size: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  animation: slide-in-left 0.3s ease-out;
  backdrop-filter: blur(8px);
}

.status-stack-text {
  font-weight: 400;
  white-space: nowrap;
}


@keyframes slide-in-left {
  from {
    transform: translateX(-20px);
    opacity: 0;
  }

  to {
    transform: translateX(0);
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,4BAA4B;;EAE5B,0BAA0B;;EAE1B,gCAAgC;EAChC,gCAAgC;;EAEhC,uBAAuB;EACvB,oBAAoB;EACpB,uBAAuB;EACvB,uBAAuB;;EAEvB,uBAAuB;EACvB,uBAAuB;;EAEvB,wBAAwB;;EAExB,2BAA2B;;EAE3B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;;EAE7B,mCAAmC;EACnC,+BAA+B;EAC/B,qCAAqC;;EAErC,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,uBAAuB;;EAEvB,wBAAwB;;EAExB,oBAAoB;;EAEpB,gCAAgC;;EAEhC,uBAAuB;;EAEvB,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;;EAE7B,+BAA+B;EAC/B,qCAAqC;;EAErC,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,wBAAwB;AACxB;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,UAAU;EACV,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,6CAA6C;EAC7C,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;GAEG;;AAEH;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,0BAA0B;EAC1B,2DAA2D;EAC3D,wDAAwD;EACxD,mDAAmD;EACnD,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,iBAAiB;EACjB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;;;;;;;;EAQE,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,iCAAiC;EACjC,iDAAiD;EACjD,oCAAoC;AACtC;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,2BAA2B;EAC3B,iCAAiC;EACjC,kDAAkD;EAClD,oCAAoC;AACtC;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,kCAAkC;EAClC,mCAAmC;EACnC,gDAAgD;AAClD;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,kCAAkC;EAClC,mCAAmC;EACnC,mDAAmD;AACrD;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,wBAAwB;EACxB,kCAAkC;EAClC,mCAAmC;EACnC,gDAAgD;AAClD;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,wBAAwB;EACxB,kCAAkC;EAClC,mCAAmC;EACnC,gDAAgD;AAClD;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,wBAAwB;EACxB,kCAAkC;EAClC,mCAAmC;EACnC,mDAAmD;AACrD;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,wBAAwB;EACxB,kCAAkC;EAClC,mCAAmC;EACnC,mDAAmD;AACrD;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,8CAA8C;EAC9C,8CAA8C;EAC9C,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,wCAAwC;EACxC,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;;EAElB,6BAA6B;EAC7B,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,SAAS;EACT,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,SAAS;EACT,SAAS;EACT,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;EAIE,wCAAwC;AAC1C;;AAEA;;EAEE,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;;EAEjB,iBAAiB;EACjB,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,UAAU;AACZ;;AAEA,+CAA+C;AAC/C;EACE,WAAW;EACX,wBAAwB;EACxB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;AACf;;AAEA,iEAAiE;AACjE,iBAAiB;AACjB;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,wCAAwC;EACxC,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC,iBAAiB;AACjB;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,wCAAwC;EACxC,YAAY;EACZ,uCAAuC;EACvC,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,SAAS;EACT,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,UAAU;EACV,2BAA2B;EAC3B,wBAAwB;EACxB,qBAAqB;EACrB,6BAA6B;EAC7B,qCAAqC;EACrC,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,4EAA4E;AAC9E;;AAEA;EACE,cAAc;EACd,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;;EAEZ,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,6BAA6B;EAC7B,yCAAyC;AAC3C;;AAEA;EACE,gDAAgD;EAChD,eAAe;AACjB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;EAClB,0BAA0B;EAC1B,4EAA4E;AAC9E;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,WAAW;;EAEX,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,mCAAmC;EACnC,0CAA0C;EAC1C,2CAA2C;EAC3C,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,0CAA0C;EAC1C,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;;AAGA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;;EAEA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF","sourcesContent":[":root {\n  --accent-base-color: #85be40;\n  --accent-fill-hover: #488100;\n\n  --primary-color-1: #00ab55;\n\n  --primary-color-hover-1: #007b55;\n  --primary-color-hover-2: #ebf9f2;\n\n  --color-text-1: #212529;\n  --color-text-2: #fff;\n  --color-text-3: #71717a;\n  --color-text-4: #515151;\n\n  --color-icon-1: #919eab;\n  --color-icon-2: #414141;\n\n  --color-hover-1: #e2e8f0;\n\n  --border-color-1: #919eab3d;\n\n  --background-color-1: #ffffff;\n  --background-color-2: #edeff1;\n  --background-color-3: #f2f3f5;\n  --background-color-4: #fbfbfc;\n\n  --scroll-color-track-1: transparent;\n  --scroll-color-thumb-1: #cbd0d6;\n  --scroll-color-thumb-hover-1: #b6bbc0;\n\n  --dropdown-background-color-1: #ebebeb;\n  --dropdown-background-color-2: #d7d7d7;\n}\n\n.darkmode {\n  --color-text-1: #fff;\n  --color-text-3: #e4e4e7;\n  --color-text-4: #c9c9c9;\n\n  --color-hover-1: #475569;\n\n  --color-icon-2: #fff;\n\n  --primary-color-hover-2: #1c3f3b;\n\n  --color-icon-1: #e2e8f0;\n\n  --background-color-1: #161c24;\n  --background-color-2: #333d48;\n  --background-color-3: #29333c;\n  --background-color-4: #212b36;\n\n  --scroll-color-thumb-1: #46525f;\n  --scroll-color-thumb-hover-1: #37424d;\n\n  --dropdown-background-color-1: #3b4957;\n  --dropdown-background-color-2: #283543;\n}\n\n.darkmode .cesium-viewer {\n  overflow: hidden;\n  color: var(--color-text-1);\n}\n\n.DPU-container-view {\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n  font-size: 14px;\n  background-color: var(--background-color-1);\n}\n\n.DPU-container-view>* {\n  box-sizing: border-box;\n}\n\n.DPU-container-view *::-webkit-scrollbar {\n  width: 5px;\n  height: 5px;\n  /* Scroll ngang */\n}\n\n.DPU-container-view *::-webkit-scrollbar-track {\n  background: var(--scroll-color-track-1);\n}\n\n.DPU-container-view *::-webkit-scrollbar-thumb {\n  background: var(--scroll-color-thumb-1);\n}\n\n.DPU-container-view *::-webkit-scrollbar-thumb:hover {\n  background: var(--scroll-color-thumb-hover-1);\n}\n\n/* mặc định của cesium */\n.cesium-viewer-bottom {\n  display: none;\n}\n\n.custom-toolbar-dpu {\n  position: absolute;\n  right: 5px;\n  top: 100px;\n  z-index: 5;\n  color: white;\n  display: flex;\n  flex-direction: column;\n}\n\n.custom-toolbar-dpu.resp-h400 {\n  flex-direction: row;\n  right: unset;\n  top: unset;\n  bottom: 25px;\n  left: 50%;\n  flex-direction: row;\n  transform: translateX(-50%);\n}\n\n.custom-toolbar-dpu.resp-h400 .container-tool-cesium {\n  flex-direction: row;\n  margin-right: 5px;\n}\n\n.custom-toolbar-dpu.resp-h400 .container-tool-cesium .container-btn-tool-cesium {\n  flex-direction: row;\n}\n\n.container-tool-cesium {\n  display: flex;\n  flex-direction: column;\n  padding: 2px;\n  border-radius: 4px;\n  background-color: var(--background-color-1);\n  box-shadow: 1px 3px 10px 0 rgba(0, 0, 0, 0.5);\n  opacity: 0.85;\n  border: none;\n  margin-top: 5px;\n}\n\n.custom-toolbar-dpu.resp-h400 .container-tool-cesium>* {\n  margin-top: 0px;\n  margin-left: 0px;\n}\n\n/* .container-tool-cesium > * {\n  margin-top: 2px;\n} */\n\n.custom-toolbar-dpu.resp-h400 .container-tool-cesium .container-btn-tool-cesium .container-tool-cesium>* {\n  margin-left: 0px;\n}\n\n.custom-toolbar-dpu.resp-h400 .container-tool-cesium .container-btn-tool-cesium>*:first-child {\n  margin-left: 0;\n}\n\n.custom-toolbar-dpu.resp-h400 .container-tool-cesium .container-btn-tool-cesium>* {\n  margin-top: 0px;\n  margin-left: 3px;\n}\n\n.custom-toolbar-dpu.resp-h400 .padding-btn-tool-cesium {\n  margin-top: 0px;\n  margin-left: 1px;\n}\n\n.custom-toolbar-dpu.resp-h400 .container-tool-cesium .container-btn-tool-cesium>*:first-child,\n.custom-toolbar-dpu.resp-h400 .container-tool-cesium .container-btn-tool-cesium>*:nth-child(2) {\n  margin-left: 0px;\n}\n\n.container-tool-cesium>*:first-child {\n  margin-top: 0;\n}\n\n.container-btn-tool-cesium {\n  display: flex;\n  flex-direction: column;\n}\n\n.container-btn-tool-cesium>* {\n  margin-top: 3px;\n}\n\n.container-btn-tool-cesium>*:first-child,\n.container-btn-tool-cesium>*:nth-child(2) {\n  margin-top: 0;\n}\n\n.padding-btn-tool-cesium {\n  margin-top: 1px;\n}\n\n/* Tooltip Styles */\n.dynamic-tooltip {\n  position: absolute;\n  background-color: var(--background-color-1);\n  color: var(--color-icon-2);\n  -webkit-box-shadow: 0px 0px 15px 0px rgba(170, 170, 170, 1);\n  -moz-box-shadow: 0px 0px 15px 0px rgba(170, 170, 170, 1);\n  box-shadow: 0px 0px 15px 0px rgba(170, 170, 170, 1);\n  padding: 5px;\n  border-radius: 4px;\n  white-space: nowrap;\n  font-size: 12px;\n  z-index: 999;\n  opacity: 0.85;\n  transition: opacity 0.3s ease;\n  text-align: right;\n  direction: rtl;\n}\n\n/* Các hướng mũi tên */\n.dynamic-tooltip-arrow-right,\n.dynamic-tooltip-arrow-left,\n.dynamic-tooltip-arrow-top,\n.dynamic-tooltip-arrow-bottom,\n.dynamic-tooltip-arrow-topLeft,\n.dynamic-tooltip-arrow-topRight,\n.dynamic-tooltip-arrow-bottomLeft,\n.dynamic-tooltip-arrow-bottomRight {\n  position: absolute;\n}\n\n/* Mũi tên bên phải */\n.dynamic-tooltip-arrow-right::after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  right: -5px;\n  transform: translateY(-50%);\n  border-top: 7px solid transparent;\n  border-left: 10px solid var(--background-color-1);\n  border-bottom: 7px solid transparent;\n}\n\n/* Mũi tên bên trái */\n.dynamic-tooltip-arrow-left::after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: -5px;\n  transform: translateY(-50%);\n  border-top: 7px solid transparent;\n  border-right: 10px solid var(--background-color-1);\n  border-bottom: 7px solid transparent;\n}\n\n/* Mũi tên phía trên */\n.dynamic-tooltip-arrow-top::after {\n  content: \"\";\n  position: absolute;\n  bottom: -5px;\n  left: 50%;\n  transform: translateX(-50%);\n  border-left: 7px solid transparent;\n  border-right: 7px solid transparent;\n  border-top: 10px solid var(--background-color-1);\n}\n\n/* Mũi tên phía dưới */\n.dynamic-tooltip-arrow-bottom::after {\n  content: \"\";\n  position: absolute;\n  top: -5px;\n  left: 50%;\n  transform: translateX(-50%);\n  border-left: 7px solid transparent;\n  border-right: 7px solid transparent;\n  border-bottom: 10px solid var(--background-color-1);\n}\n\n/* Mũi tên phía trên bên trái */\n.dynamic-tooltip-arrow-topLeft::after {\n  content: \"\";\n  position: absolute;\n  bottom: -5px;\n  left: 0px;\n  transform: translateX(0);\n  border-left: 7px solid transparent;\n  border-right: 7px solid transparent;\n  border-top: 10px solid var(--background-color-1);\n}\n\n/* Mũi tên phía trên bên phải */\n.dynamic-tooltip-arrow-topRight::after {\n  content: \"\";\n  position: absolute;\n  bottom: -5px;\n  right: 0px;\n  transform: translateX(0);\n  border-left: 7px solid transparent;\n  border-right: 7px solid transparent;\n  border-top: 10px solid var(--background-color-1);\n}\n\n/* Mũi tên phía dưới bên trái */\n.dynamic-tooltip-arrow-bottomLeft::after {\n  content: \"\";\n  position: absolute;\n  top: -5px;\n  left: 0px;\n  transform: translateX(0);\n  border-left: 7px solid transparent;\n  border-right: 7px solid transparent;\n  border-bottom: 10px solid var(--background-color-1);\n}\n\n/* Mũi tên phía dưới bên phải */\n.dynamic-tooltip-arrow-bottomRight::after {\n  content: \"\";\n  position: absolute;\n  top: -5px;\n  right: 0px;\n  transform: translateX(0);\n  border-left: 7px solid transparent;\n  border-right: 7px solid transparent;\n  border-bottom: 10px solid var(--background-color-1);\n}\n\n.btn-tool-cesium {\n  border: 1px solid rgba(34, 34, 34, 0);\n  border-radius: 4px;\n  cursor: pointer;\n  float: left;\n  height: 28px;\n  text-align: center;\n  position: relative;\n  width: 28px;\n  padding: 2px 2px;\n  background-color: transparent;\n  line-height: 1px;\n}\n\n.btn-tool-cesium svg {\n  width: 100%;\n  height: 100%;\n  color: var(--color-icon-2);\n  stroke: var(--color-icon-2);\n  fill: var(--color-icon-2);\n}\n\n.btn-tool-cesium:hover svg {\n  color: var(--primary-color-1);\n  stroke: var(--primary-color-1);\n  fill: var(--primary-color-1);\n}\n\n.btn-tool-cesium.done {\n  background-color: var(--primary-color-1);\n  font-size: unset;\n  width: 28px;\n  height: 28px;\n}\n\n.btn-tool-cesium.done:hover {\n  background-color: var(--primary-color-hover-1);\n  border: 1px solid var(--primary-color-hover-1);\n  color: #fff;\n}\n\n.btn-tool-cesium.done:hover svg {\n  color: #fff;\n  stroke: #fff;\n  fill: #fff;\n}\n\n.btn-tool-cesium:hover {\n  background-color: transparent;\n  border: 1px solid var(--primary-color-1);\n  color: var(--primary-color-1);\n}\n\n.btn-tool-cesium:focus {\n  background-color: transparent;\n  border-radius: 3px;\n  box-shadow: inset 0 2px 2px 0 transparent;\n  outline: none;\n  border-color: transparent;\n}\n\n.btn-tool-cesium:focus:hover {\n  border: 1px solid var(--primary-color-1);\n}\n\n.btn-tool-cesium:focus:hover svg {\n  color: var(--primary-color-1);\n  stroke: var(--primary-color-1);\n  fill: var(--primary-color-1);\n}\n\n.btn-tool-cesium.active {\n  background-color: transparent;\n  border-radius: 3px;\n\n  color: var(--primary-color-1);\n  border: 1px solid var(--primary-color-1);\n  outline: none;\n}\n\n.btn-tool-cesium.active svg {\n  color: var(--primary-color-1);\n  stroke: var(--primary-color-1);\n  fill: var(--primary-color-1);\n}\n\n.zoom-earth {\n  position: absolute;\n  right: 5px;\n  z-index: 5;\n  color: white;\n}\n\n.zoom-earth.in {\n  bottom: 105px;\n}\n\n.zoom-earth.out {\n  bottom: 65px;\n}\n\n.zoom-earth.in.resp-zoom-earth-in-h550 {\n  top: 50px;\n  left: 5px;\n  right: unset;\n  bottom: unset;\n}\n\n.zoom-earth.out.resp-zoom-earth-out-h550 {\n  top: 87px;\n  left: 5px;\n  right: unset;\n  bottom: unset;\n}\n\n.body-dialog-valid-token {\n  width: 100%;\n  height: 100%;\n  padding: 10px;\n  display: flex;\n}\n\n.icon-dialog-error {\n  background-color: #fff;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.icon-dialog-error svg {\n  width: 100%;\n  height: 100%;\n  fill: #d75a4a;\n  stroke: #d75a4a;\n}\n\ninput.dpu-input-check-box {\n  cursor: pointer;\n  accent-color: var(--primary-color-1);\n}\n\ninput.dpu-input-check-box+label {\n  display: inline-block;\n  vertical-align: middle;\n  cursor: pointer;\n  margin-left: 5px;\n}\n\ninput.dpu-input-text[type=\"number\"]:focus,\ninput.dpu-input-text[type=\"number\"]:focus-visible,\ninput.dpu-input-text[type=\"text\"]:focus,\ninput.dpu-input-text[type=\"text\"]:focus-visible {\n  border: 1px solid var(--primary-color-1);\n}\n\ninput.dpu-input-text[type=\"number\"],\ninput.dpu-input-text[type=\"text\"] {\n  color: var(--color-text-1);\n  width: 100%;\n  height: 30px;\n  border: 1px solid #ced4da;\n  background: none;\n  box-sizing: border-box;\n  border-radius: 4px;\n  padding-block: 0px;\n  padding-inline: 0;\n\n  padding-left: 8px;\n  outline: none;\n  box-shadow: none;\n}\n\ninput.dpu-input-text[type=\"number\"]::placeholder,\ninput.dpu-input-text[type=\"text\"]::placeholder {\n  color: var(--color-text-4);\n}\n\ninput.dpu-inpu-color[type=\"color\"] {\n  background: var(--background-color-3);\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  padding: 0px 2px;\n}\n\ninput.dpu-input-text[type=\"number\"]::-webkit-outer-spin-button,\ninput.dpu-input-text[type=\"number\"]::-webkit-inner-spin-button {\n  width: 25px;\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 100%;\n  color: red;\n}\n\n/*********** Baseline, reset styles ***********/\ninput.dpu-input-range[type=\"range\"] {\n  width: 100%;\n  -webkit-appearance: none;\n  appearance: none;\n  background: transparent;\n  cursor: pointer;\n}\n\n/* Removes default focus */\ninput.dpu-input-range[type=\"range\"]:focus {\n  outline: none;\n}\n\n/******** Chrome, Safari, Opera and Edge Chromium styles ********/\n/* slider track */\ninput.dpu-input-range[type=\"range\"]::-webkit-slider-runnable-track {\n  background-color: var(--background-color-3);\n  border-radius: 5px;\n  height: 5px;\n}\n\n/* slider thumb */\ninput.dpu-input-range[type=\"range\"]::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  /* Override default look */\n  appearance: none;\n  margin-top: -5.5px;\n  /* Centers thumb on the track */\n  background-color: var(--primary-color-1);\n  border-radius: 50%;\n  height: 12px;\n  width: 12px;\n}\n\ninput.dpu-input-range[type=\"range\"]:focus::-webkit-slider-thumb {\n  outline: 2px solid var(--primary-color-1);\n  outline-offset: 2px;\n}\n\n/*********** Firefox styles ***********/\n/* slider track */\ninput.dpu-input-range[type=\"range\"]::-moz-range-track {\n  background-color: var(--background-color-3);\n  border-radius: 5px;\n  height: 5px;\n}\n\n/* slider thumb */\ninput.dpu-input-range[type=\"range\"]::-moz-range-thumb {\n  background-color: var(--primary-color-1);\n  border: none;\n  /*Removes extra border that FF applies*/\n  border-radius: 50%;\n  height: 12px;\n  width: 12px;\n}\n\ninput.dpu-input-range[type=\"range\"]:focus::-moz-range-thumb {\n  outline: 2px solid var(--primary-color-1);\n  outline-offset: 2px;\n}\n\n.dpu-select-box {\n  position: relative;\n  display: block;\n  width: 100%;\n  margin: 0 auto;\n  font-size: 12px;\n  color: #60666d;\n}\n\n.dpu-select-box__current {\n  position: relative;\n  cursor: pointer;\n  outline: none;\n  border-radius: 5px;\n}\n\n.dpu-select-box__current:focus+.dpu-select-box__list {\n  opacity: 1;\n  animation-name: none;\n}\n\n.dpu-select-box__current:focus .dpu-select-box__option {\n  cursor: pointer;\n}\n\n.dpu-select-box__icon {\n  position: absolute;\n  top: 50%;\n  right: 15px;\n  transform: translateY(-50%);\n  width: 10px;\n  opacity: 0.3;\n  transition: 0.2s ease;\n}\n\n.dpu-select-box__value {\n  display: flex;\n}\n\n.dpu-select-box__input {\n  display: none;\n}\n\n.dpu-select-box__input:checked+.dpu-select-box__input-text {\n  display: block;\n}\n\n.dpu-select-box__input-text {\n  display: none;\n  width: 100%;\n  margin: 0;\n  padding: 0 5px;\n  height: 30px;\n  background-color: #fff;\n  line-height: 30px;\n  border-radius: 5px;\n  border: 1px solid #ccc;\n}\n\n.dpu-select-box__list {\n  position: absolute;\n  width: 100%;\n  padding: 0;\n  list-style: none;\n  opacity: 0;\n  animation-name: dpuHideList;\n  animation-duration: 0.5s;\n  animation-delay: 0.5s;\n  animation-fill-mode: forwards;\n  animation-timing-function: step-start;\n  background-color: #fff;\n  max-height: 300px;\n  overflow: auto;\n  border-radius: 5px;\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n}\n\n.dpu-select-box__option {\n  display: block;\n  padding: 10px;\n  /* background-color: #fff; */\n}\n\n.dpu-container-title {\n  display: flex;\n  align-items: center;\n}\n\n.dpu-container-title div:first-child {\n  width: 3px;\n  height: 15px;\n\n  margin-right: 5px;\n}\n\n.dpu-select-box__option:hover,\n.dpu-select-box__option:focus {\n  color: #546c84;\n  background-color: #fbfbfb;\n}\n\n@keyframes dpuHideList {\n  from {\n    transform: scaleY(1);\n  }\n\n  to {\n    transform: scaleY(0);\n  }\n}\n\n.dpu-tree-item.active .dpu-loading-animation {\n  /* filter: grayscale(100%); */\n  filter: grayscale(100%) brightness(1000%);\n}\n\n.dpu-loading-animation {\n  animation: dpu-rotate-loading 1s linear infinite;\n  max-width: none;\n}\n\n@keyframes dpu-rotate-loading {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.dpu-waiting-load-model {\n  position: absolute;\n  max-width: 200px;\n  z-index: 10;\n  bottom: 30px;\n  left: 5px;\n  padding: 5px 10px;\n  background-color: var(--background-color-4);\n  border-radius: 4px;\n  color: var(--color-text-1);\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n}\n\n/* Reusable Bottom-Left Status Stack Container */\n#status-stack-container {\n  position: absolute;\n  bottom: 65px;\n  left: 5px;\n  z-index: 99;\n\n  pointer-events: none;\n  border-radius: 4px;\n}\n\n.status-stack-item {\n\n  padding: 4px 6px;\n  color: var(--color-text-1, #ffffff);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background-color: var(--background-color-4);\n  border-radius: 4px;\n  font-family: inherit;\n  font-size: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);\n  animation: slide-in-left 0.3s ease-out;\n  backdrop-filter: blur(8px);\n}\n\n.status-stack-text {\n  font-weight: 400;\n  white-space: nowrap;\n}\n\n\n@keyframes slide-in-left {\n  from {\n    transform: translateX(-20px);\n    opacity: 0;\n  }\n\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
